<div class="cads-list-item" [class.cads-list-item--single-line]="_singleLine()">
  <div class="cads-list-item__leading" aria-hidden="true">
    <cads-icon-view-bit [config]="_leadingIconConfig()" />
  </div>
  <div class="cads-list-item__body">
    <div class="cads-list-item__title-row">
      <span class="cads-list-item__title" [style.color]="_titleColor()">{{ config().title }}</span>
      @if (_badgeConfig(); as badge) {
        <cads-badge-bit [config]="badge" />
      }
    </div>
    @if (!_singleLine()) {
      <p class="cads-list-item__description" [style.color]="_descriptionColor()">{{ config().description }}</p>
    }
  </div>
  @if (_trailingLabel(); as trailingLabel) {
    <span class="cads-list-item__trailing" [style.color]="_trailingColor()">{{ trailingLabel }}</span>
  }
</div>
